import { useEffect, useState } from "react";
import PageLayout from "../common/PageLayout";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { TbListDetails } from "react-icons/tb";
import { AppEntryRepository } from "../repositories/AppEntryRepository";
import { Enumerations } from "../../config/Enumerations";
import EntryDetails from "./EntryDetails";
import EntryAttachedDocuments from "./EntryAttachedDocuments";
import EntryOtherDocuments from "./EntryOtherDocuments";
import EntryDecisions from "./EntryDecisions";
import ApplicantEntryCorrection from "./ApplicantEntryCorrection";
import EntryCorrectedAttachments from "./EntryCorrectedAttachments";
import { StatusStepper } from "./StatusStepper";

export default function EntryDetailedView() {
  const { id } = useParams();
  const auth = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(true);
  const [appEntry, setAppEntry] = useState(null);
  const [resolvedActiveStep, setResolvedActiveStep] = useState();

  useEffect(() => {
    if (id) {
      getById();
    }
  }, [id]);

  const getById = () => {
    setLoading(true);
    AppEntryRepository.getById(id)
      .then((res) => {
        setLoading(false);
        setAppEntry(res.data);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  useEffect(() => {
    if (appEntry) {
      if (appEntry.status === "SUBMITTED") {
        setResolvedActiveStep(0);
      } else if (appEntry.status === "DONE") {
        setResolvedActiveStep(3);
      } else {
        setResolvedActiveStep(1);
      }
    }
  }, [appEntry]);

  const attachedDocuments = appEntry?.attachments?.filter((attachment) =>
    [
      "URBAN_PLANING_PROJECT_DWG",
      "URBAN_PLANING_PROJECT_PDF",
      "TRAFFIC_ENGINEERING_PROJECT_DWG",
      "TRAFFIC_ENGINEERING_PROJECT_PDF",
      "PROJECT_REVISION",
    ].includes(attachment.documentType),
  );

  const otherDocuments = appEntry?.attachments?.filter((attachment) =>
    ["PROOF_OF_PAYMENT", "POWER_OF_ATTORNEY"].includes(attachment.documentType),
  );
  const correctedDocuments = appEntry?.attachments?.filter((attachment) =>
    ["CORRECTED"].includes(attachment.documentType),
  );

  return (
    <PageLayout
      title={`Барање ${appEntry?.trackingNumber}`}
      Icon={TbListDetails}
      subtitle={"Идентификатор"}
    >
      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="300px"
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Grid item xs={12}>
            <Grid container spacing={3} alignItems="flex-start">
              <Grid item xs={12} md={12} sx={{ mb: 1, mt: 1 }}>
                <StatusStepper
                  steps={[
                    {
                      label: "Поднесено",
                      date: `${appEntry?.dateSubmitted}`,
                    },
                    { label: "Во обработка" },
                    { label: "Завршено" },
                  ]}
                  activeStep={resolvedActiveStep}
                />
              </Grid>

              {appEntry?.status === "CORRECTION" && (
                <>
                  <Grid item xs={12} md={12}>
                    <ApplicantEntryCorrection
                      appEntry={appEntry}
                      setAppEntry={setAppEntry}
                    />
                  </Grid>
                </>
              )}

              <EntryDetails appEntry={appEntry} />

              <EntryDecisions appEntry={appEntry} />

              <EntryAttachedDocuments attachedDocuments={attachedDocuments} />

              {otherDocuments?.length > 0 && (
                <Grid item xs={12} md={6}>
                  <EntryOtherDocuments
                    otherDocuments={otherDocuments}
                    appEntry={appEntry}
                  />
                </Grid>
              )}

              {correctedDocuments?.length > 0 && (
                <Grid item xs={12} md={6}>
                  <EntryCorrectedAttachments
                    correctedDocuments={correctedDocuments}
                    appEntry={appEntry}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </>
      )}
    </PageLayout>
  );
}
